import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    certificateInfo: {
      code: '',
      password: ''
    },
    contents: {}
  },
  getters: {
    certificateInfo(state) {
      return state.certificateInfo
    },
    contents(state) {
      return state.contents
    }
  },
  mutations: {
    setCertificateInfo(state, payload) {
      state.certificateInfo.code = payload.code
      state.certificateInfo.password = payload.password
    },
    setContents(state, payload) {
      state.contents = payload.contents
    }
  },
  actions: {
    setCertificateInfo({ commit }, payload) {
      commit('setCertificateInfo', payload)
    },
    setContents({ commit }, payload) {
      commit('setContents', payload)
    }
  }
})
